import { FC } from "react";
import { capitalize } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useAppSelector } from "@/store/hooks";
import { budgetDetailsPeriodSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsPeriodSelector";
import { BudgetDetailsSectionWrapper } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/common/BudgetDetailsSectionWrapper";
import { BudgetDetailsHistoryChart } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/history-section/BudgetDetailsHistoryChart";
import { BudgetDetailsHistoryTable } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/history-section/BudgetDetailsHistoryTable";

export const BudgetDetailsHistorySection: FC = () => {
  const period = useAppSelector(budgetDetailsPeriodSelector);
  const title = `${capitalize(period ?? "")} Budget History`;

  return (
    <BudgetDetailsSectionWrapper title={title}>
      <Stack width="100%" p={1} spacing={1.5}>
        <BudgetDetailsHistoryChart />
        <BudgetDetailsHistoryTable />
      </Stack>
    </BudgetDetailsSectionWrapper>
  );
};
